import { render, staticRenderFns } from "./EmployeeTag.vue?vue&type=template&id=57dc1baa"
import script from "./EmployeeTag.vue?vue&type=script&lang=js"
export * from "./EmployeeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports